import { render } from "./PageInfo.vue?vue&type=template&id=2e9fd32c&scoped=true&lang=html"
import script from "./PageInfo.vue?vue&type=script&lang=js"
export * from "./PageInfo.vue?vue&type=script&lang=js"

import "./PageInfo.vue?vue&type=style&index=0&id=2e9fd32c&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9fd32c"]])

export default __exports__